import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../rtkQuery';
import { restApiFormData } from '../axios';
import { API_ENDPOINTS } from '../constants';

export const companyAPI = createApi({
    reducerPath: 'companyAPI',
    baseQuery: axiosBaseQuery(restApiFormData),
    endpoints: (builder) => ({
        getAllCompanies: builder.mutation({
            query: () => ({
                url: API_ENDPOINTS.GET_ALL_COMPANIES,
                method: 'GET',
            }),
        }),
        searchCompanies: builder.mutation({
            query: (query) => ({
                url: `${API_ENDPOINTS.SEARCH_COMPANIES}?${query.toString()}`,
                method: 'POST',
            }),
        }),
        listCompanies: builder.mutation({
            query: (query) => ({
                url: `${API_ENDPOINTS.LIST_COMPANIES}?${query.toString()}`,
                method: 'POST',
            }),
        }),
        displayCompany: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.DISPLAY_COMPANY,
                method: 'POST',
                data,
            }),
        }),
        deleteCompany: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.DELETE_COMPANY,
                method: 'POST',
                data,
            }),
        }),
        saveCompany: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.SAVE_COMPANY,
                method: 'POST',
                data,
            }),
        }),
        modifyCompanyAction: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.MODIFY_COMPANY_ACTION,
                method: 'POST',
                data,
            }),
        }),
        modifyCompanyConfig: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.MODIFY_COMPANY_CONFIG,
                method: 'POST',
                data,
            }),
        }),
        modifyCompanyConfigAction: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.MODIFY_COMPANY_CONFIG_ACTION,
                method: 'POST',
                data,
            }),
        }),
    }),
});

export const {
    useGetAllCompaniesMutation,
    useSearchCompaniesMutation,
    useListCompaniesMutation,
    useDisplayCompanyMutation,
    useDeleteCompanyMutation,
    useSaveCompanyMutation,
    useModifyCompanyActionMutation,
    useModifyCompanyConfigMutation,
    useModifyCompanyConfigActionMutation,
} = companyAPI;
